import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Offcanvas, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "context/AuthContext";
import {
  faBars,
  faLayerGroup,
  faQuestion,
  faUserGroup,
  faHouse,
  faSignOutAlt,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/imgs/logo-principal-160x82.png";
import "./styles.scss";

const Sidebar = () => {
  const { userData, handleLogout } = useContext(Context);
  const { showLoader } = useContext(Context);
  const [show, setShow] = useState(false);

  const handleToggle = () => setShow(!show);

  const locations = [
    {
      path: "/",
      name: "Quiz",
      icon: faHouse,
    },
    {
      path: "/admin/categoria",
      name: "Categorias",
      icon: faLayerGroup,
    },
    {
      path: "/admin/questao",
      name: "Questões",
      icon: faQuestion,
    },
    {
      path: "/admin/usuarios",
      name: "Usuários",
      icon: faUserGroup,
    },
    {
      path: "/admin/relatorio",
      name: "Relatório",
      icon: faFile,
    },
  ];

  async function logout(event) {
    event.preventDefault();
    showLoader(true);
    await handleLogout();
    showLoader(false);
  }

  return (
    <div className={`sidebar-container ${show ? "expanded" : "collapsed"}`}>
      <Offcanvas
        bsPrefix="sidebar"
        show={show}
        onHide={handleToggle}
        backdrop={false}
        responsive="sm"
      >
        <Offcanvas.Header closeButton>
          {show && (
            <Offcanvas.Title className="m-2">
              <Link to="/admin" className="link-admin">
                <Image src={logo} alt="Logo" fluid className="d-flex m-4" />
              </Link>
            </Offcanvas.Title>
          )}
          <Button
            variant="transparent"
            onClick={handleToggle}
            className="sidebar-toggle"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul>
            {locations.map((item, index) => (
              <li key={index}>
                <div className="link-content">
                  <Link to={item.path} onClick={handleToggle}>
                    {show ? (
                      <span className="link-text">
                        <FontAwesomeIcon
                          icon={item.icon}
                          style={{
                            display: "inline-block",
                            width: "20px",
                            padding: "0 10px",
                          }}
                        />
                        {item.name}
                      </span>
                    ) : (
                      <FontAwesomeIcon icon={item.icon} className="link-icon" />
                    )}
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
      <div className="logout-section">
        <Button variant="link" onClick={logout} className="logout-button">
          <FontAwesomeIcon icon={faSignOutAlt} />
          {show && <span className="logout-text">Sair</span>}
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
